<div class="wrapper">
  <!-- 选择货币 -->
  <div class="main-container selet-cont" [class.is-open]="seletOpen">
    <div class="heading">
      <div class="tt">
        <i class="icon-back" [class]="isShowBackIcon ? 'opacity-1' : 'opacity-0'" (click)="back()"></i>
        <div>{{ 'sel_coin' | translate }}</div>
      </div>
      <div class="right">
        <div class="search-contanier">
          <app-customize-input
            [width]="'110px'"
            [leftIcon]="'icon-search'"
            [placeholder]="'search' | translate"
            [(value)]="keyword"
            [extend]="true"
          >
          </app-customize-input>
        </div>
        <div class="btn-edit" *ngIf="!data.purely" (click)="seletOpen = false">
          <i class="icon-add-del"></i>
        </div>
        <div class="btn-close close-anim" (click)="close()">
          <i class="icon-error"></i>
        </div>
      </div>
    </div>

    <div class="options-container">
      <app-scrollbar>
        <div class="wrap" [appLoading]="isLoading">
          <ng-container *ngIf="data.useData">
            <ng-container *ngFor="let item of data.useData | filterByText : keyword : ['currency', 'name']">
              <ng-container *ngTemplateOutlet="selectRow; context: { item: item }"></ng-container>
            </ng-container>
            <app-empty
              *ngIf="(data.useData | filterByText : keyword : ['currency', 'name']).length === 0 && !isLoading"
              [text]="'search_unfind' | translate"
              [icon]="'assets/temp5/empty.png'"
            ></app-empty>
          </ng-container>
          <ng-container *ngIf="!data.useData">
            <ng-container *ngFor="let item of selectCurrencies | filterByText : keyword : ['currency', 'name']">
              <ng-container *ngTemplateOutlet="selectRow; context: { item: item }"></ng-container>
            </ng-container>
            <app-empty
              *ngIf="(selectCurrencies | filterByText : keyword : ['currency', 'name']).length === 0 && !isLoading"
              [text]="'search_unfind' | translate"
              [icon]="'assets/temp5/empty.png'"
            ></app-empty>
          </ng-container>
        </div>
      </app-scrollbar>
    </div>
  </div>
  <!-- 编辑货币 -->
  <div class="main-container edit-cont" [class.is-open]="!seletOpen">
    <div class="heading">
      <div class="tt">
        <i class="icon-back only" (click)="seletOpen = true"></i>
      </div>
      <div class="search-contanier">
        <app-customize-input
          style="flex: 1"
          [width]="'100%'"
          [leftIcon]="'icon-search'"
          [placeholder]="'search' | translate"
          [(value)]="keyword"
        >
        </app-customize-input>
      </div>
      <div class="right">
        <div class="btn-close close-anim" (click)="close()">
          <i class="icon-error"></i>
        </div>
      </div>
    </div>
    <div class="menu" *ngIf="!seletOpen && !keyword">
      <mat-tab-group
        class="unit-mat-tab-group"
        disableRipple="true"
        [selectedIndex]="selectIndex"
        (selectedIndexChange)="selectMenu($event)"
      >
        <mat-tab [label]="item.title" *ngFor="let item of menu; let index = index"></mat-tab>
      </mat-tab-group>
    </div>
    <div class="title-bar" *ngIf="!keyword">
      <div class="tt">{{ 'my_favo_curr' | translate }}</div>
      <div class="btn-sort" (click)="isSortAZ = !isSortAZ" [class.up]="!isSortAZ">
        <i class="icon-dep-download"></i>
      </div>
    </div>
    <div class="options-container">
      <app-scrollbar [appLoading]="isLoading">
        <div class="wrap">
          <ng-container *ngIf="!data.useData">
            <ng-container
              *ngFor="
                let item of editCurrencies
                  | filterByText : keyword : ['currency', 'name']
                  | filterByKeyValue : 'isDigital' : (selectIndex == 1 ? true : false)
                  | sortByKey : 'currency' : isSortAZ
              "
            >
              <ng-container *ngTemplateOutlet="editRow; context: { item: item }"></ng-container>
            </ng-container>
            <app-empty
              *ngIf="(editCurrencies | filterByText : keyword : ['currency', 'name']).length === 0 && !isLoading"
              [text]="'search_unfind' | translate"
              [icon]="'assets/temp5/empty.png'"
            ></app-empty>
          </ng-container>
        </div>
      </app-scrollbar>
    </div>
  </div>

  <!--select template -->
  <ng-template #selectRow let-item="item">
    <div class="select-row onact96" (click)="handleSelect(item)">
      <div>
        <img class="icon" *ngIf="item.currency" [src]="item.currency | currencyIcon" />
        <div class="infor">
          <span class="span-1">{{ (item.currency | uppercase) || item.name }}</span>
        </div>
      </div>
      <div class="rate-clounm" *ngIf="data.showBalance">
        <i class="animation-icon-loading-dot" *ngIf="isBalanceLoading"><i></i><i></i><i></i><i></i></i>
        <ng-container *ngIf="!isBalanceLoading">
          <ng-container
            *ngTemplateOutlet="
              currencyItemRight;
              context: {
                conversionCurrencyData: currencyWalletService.conversionCurrency$ | async,
                item: item,
                balance: item.balance
              }
            "
          ></ng-container>
        </ng-container>
      </div>
    </div>
  </ng-template>
  <!--edit template -->
  <ng-template #editRow let-item="item">
    <div class="edit-row">
      <div>
        <img class="icon" [src]="item.currency | currencyIcon" />
        <div class="infor">
          <span class="span-1">{{ item.currency | uppercase }}</span>
        </div>
      </div>
      <div class="toggle-wrap">
        <span>{{ item.name }}</span>
        <mat-slide-toggle class="unit-mat-slide-toggle" [(ngModel)]="item.display" (change)="saveCurrencyDisplay()">
        </mat-slide-toggle>
      </div>
    </div>
  </ng-template>
  <!-- 币种栏右边 -->
  <ng-template
    #currencyItemRight
    let-conversionCurrencyData="conversionCurrencyData"
    let-item="item"
    let-balance="balance"
  >
    <div *ngIf="conversionCurrencyData.enable" class="conversion-value">
      <div class="skeleton-loading" *ngIf="conversionCurrencyData.loading"></div>
      <ng-container *ngIf="!conversionCurrencyData.loading && conversionCurrencyData.rate.length > 0">
        {{ conversionCurrencyData.currency.symbol }}
        {{
          currencyWalletService.amountAfterCalculateRate(balance, item.currency)
            | currencyValue : conversionCurrencyData.currency.currency
        }}
      </ng-container>
    </div>
    <div class="amount-value" [class.alone]="!conversionCurrencyData.enable">
      {{ balance | currencyValue : item.currency }}
    </div>
  </ng-template>
</div>
